import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';


export const ProductPreview = styled.div`
  width: 50%;
  padding: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img {
    display: block;
    max-width: 100%;
    max-height: 450px;
    height: auto;
  }

  @media (max-width: 990px) {
    padding: 30px 40px 60px;
  }
  @media (max-width: 767px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 30px 25px 60px;
    order: 0;
  }
`;

export const BackButton = styled.div`
  position: absolute;
  top: 60px;
  left: 60px;
  z-index: 999;

  @media (max-width: 990px) {
    top: 20px;
    left: 25px;
  }
  .reusecore__button {
    font-family: 'Lato', sans-serif;
    font-size: ${themeGet('fontSizes.1', '13')}px;
    font-weight: ${themeGet('fontWeights.6', '700')};
    color: ${themeGet('colors.darkRegular', '#77798C')};
    height: 30px;
    .btn-icon {
      margin-right: 5px;
    }
    .btn-text {
      padding: 0;
    }
  }
`;

export const ProductInfo = styled.div`
  width: 50%;
  border-left: 1px solid ${themeGet('colors.borderColor', '#f1f1f1')};
  padding: 55px 60px;

  @media (max-width: 990px) {
    padding: 30px 40px;
  }
  @media (max-width: 767px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 30px 25px;
    border: 0;
    order: 1;
  }
`;

export const SaleTag = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  background-color: #f4c243;
  padding: 0 10px;
  line-height: 24px;
  border-radius: 12px;
  display: inline-block;
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const DiscountPercent = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  line-height: 24px;
  background-color: #fc5c63;
  padding-left: 20px;
  padding-right: 15px;
  position: relative;
  display: inline-block;
  position: absolute;
  bottom: 180px;
  right: -60px;

  &:before {
    content: '';
    position: absolute;
    left: -8px;
    top: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 8px 12px 0;
    border-color: transparent #fc5c63 transparent transparent;
  }

  &:after {
    content: '';
    position: absolute;
    left: -8px;
    bottom: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 12px 8px;
    border-color: transparent transparent #fc5c63 transparent;
  }
`;

export const ProductTitle = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: ${themeGet('fontSizes.4', '21')}px;
  font-weight: ${themeGet('fontWeights.6', '700')};
  color: ${themeGet('colors.darkBold', '#0D1136')};
  line-height: 1.2;
  margin-bottom: 10px;
`;

export const ProductWeight = styled.div`
  font-family: 'Lato', sans-serif;
  font-size: ${themeGet('fontSizes.1', '13')}px;
  font-weight: ${themeGet('fontWeights.3', '400')};
  color: ${themeGet('colors.darkRegular', '#77798C')};
`;

export const ProductDescription = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: ${themeGet('fontSizes.2', '15')}px;
  font-weight: ${themeGet('fontWeights.3', '400')};
  color: ${themeGet('colors.darkMedium', '#424561')};
  line-height: 2;
  margin-top: 30px;
  margin-bottom: 80px;
`;

export const ProductCartWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProductPriceWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductPrice = styled.div`
  font-family: 'Lato', sans-serif;
  font-size: ${themeGet('fontSizes.3', '19')}px;
  font-weight: ${themeGet('fontWeights.6', '700')};
  color: ${themeGet('colors.primary', '#009E7F')};
`;

export const SalePrice = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: ${themeGet('fontSizes.2', '15')}px;
  font-weight: ${themeGet('fontWeights.3', '400')};
  color: ${themeGet('colors.yellow', '#FBB979')};
  font-style: italic;
  padding: 0 5px;
  overflow: hidden;
  margin-right: 15px;
  position: relative;
  display: flex;

  &:before {
    content: '';
    width: 100%;
    height: 1px;
    display: inline-block;
    background-color: ${themeGet('colors.yellow', '#FBB979')};
    position: absolute;
    top: 50%;
    left: 0;
  }
`;

export const ProductCartBtn = styled.div`
  .reusecore__button {
    border-radius: 20px;
    padding-left: 20px;
    padding-right: 20px;

    .btn-icon {
      margin-right: 5px;

      svg {
        width: 14px;
        height: auto;
        @media (max-width: 990px) {
          width: 14px;
        }
      }
    }
  }
  .quantity {
    width: 115px;
    height: 38px;
  }
`;

export const ProductMeta = styled.div`
  margin-top: 60px;
`;

export const MetaSingle = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* align-items: center; */
`;

export const MetaItem = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: ${themeGet('fontSizes.1', '13')}px;
  font-weight: ${themeGet('fontWeights.6', '700')};
  color: ${themeGet('colors.darkBold', '#0D1136')};
  margin-right: 10px;
  background-color: ${themeGet('colors.lightColor', '#f7f7f7')};
  padding: 15px;
  margin: 5px;
  border-radius: 6px;
  cursor: pointer;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RelatedItems = styled.div`
  margin-top: 70px;
  margin-left: 55px;
  margin-right: 55px;

  @media (max-width: 990px) {
    margin-top: 50px;
    margin-left: 15px;
    margin-right: 15px;
  }
  > h2 {
    font-family: 'Poppins', sans-serif;
    font-size: ${themeGet('fontSizes.4', '21')}px;
    font-weight: ${themeGet('fontWeights.6', '700')};
    color: ${themeGet('colors.darkBold', '#0D1136')};
    line-height: 1.2;
    margin-left: 15px;
    margin-bottom: 30px;
    @media (max-width: 767px) {
      margin-left: 0;
      margin-bottom: 25px;
    }
  }

  > div > div {
    flex: 0 0 20%;
    max-width: 20%;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 30px;

    @media (max-width: 1500px) {
      flex: 0 0 20%;
      max-width: 20%;
    }
    @media (max-width: 1400px) {
      flex: 0 0 25%;
      max-width: 25%;
    }
    @media (max-width: 1060px) {
      flex: 0 0 33.3333333%;
      max-width: 33.3333333%;
    }
    @media (max-width: 1199px) and (min-width: 991px) {
      padding-left: 10px;
      padding-right: 10px;
    }
    @media (max-width: 768px) {
      padding-left: 7.5px;
      padding-right: 7.5px;
      margin-bottom: 15px;
    }
    @media (max-width: 767px) {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
`;




export const DescriptionContainer = styled.div`
  & p {
    margin-bottom: 1em;
    color: #6f7287;
    font-size: 1rem;
    margin: 1.25rem 0;
    line-height: 1.75;
    // color: rgba(0, 0, 0, 0.87);
  }
  & li {
    list-style: circle;
    color: #6f7287;
  }
  /* Headings */
  & h1 {
    font-size: 3rem;
    font-weight: 700;
  }
  & h2 {
    font-size: 2rem;
  }
  & h3 {
    font-size: 1.5rem;
  }
  & h4 {
    font-size: 1.2rem;
  }
  & h5 {
    font-size: 1rem;
  }
  & .heading {
    margin: 3.5rem 0 2rem 0;
    font-weight: 600;
  }
  & .heading > span[id] {
    display: block;
    position: absolute;
    visibility: hidden;
    margin-top: -128px;
    padding-top: 128px;
  }
  & .heading > a {
    color: inherit;
  }
  & .heading > a:hover {
    color: inherit;
    border-bottom: 1px dotted;
  }
  & .heading > a:hover ~ .permalink {
    visibility: visible;
  }
  & .heading > .permalink {
    visibility: hidden;
    display: none;
  }

  @media (min-width: 992px) {
    & .heading > a {
      margin-right: 0.5rem;
    }
    & .heading > .permalink {
      display: inline-block;
    }
  }

  /* Inline code */
  & code.inline {
    color: rgb(212, 0, 255);
    font-size: 0.9em;
    white-space: pre-wrap;
    transition: color 0.2s ease;
  }

  /* Code */
  & pre {
    background: #1d1f21;
    color: #f8f8f2;
    white-space: pre;
    overflow: auto;
    padding: 1.5rem;
    margin: 1.5rem 0;
    border-radius: 3px;
    -webkit-overflow-scrolling: touch;
  }
  & pre > code {
    font-size: 14px;
    line-height: 20px;
  }

  /* Links */
  & a.absolute > code.inline {
    color: #0074de;
  }
  & a.absolute:hover > code.inline {
    color: #68b5fb;
  }
  & a.relative {
    color: inherit;
    font-size: inherit;
    border-bottom: 1px dotted;
  }
  & a.relative:hover {
    color: gray;
    text-decoration: none;
  }
  & a.relative:hover > code.inline {
    color: gray;
  }

  /* details */
  & details {
    margin: 1.5rem 0;
    padding: 0.5rem 1rem;
    background: #fafafa;
    border: 1px solid #eaeaea;
    border-radius: 3px;
  }
  & details[open] {
    overflow: hidden;
  }
  & details > summary {
    font-weight: 500;
    outline: none;
    cursor: pointer;
  }

  /* Quotes */
  & blockquote {
    color: #666666;
    background: #fafafa;
    border: 1px solid #eaeaea;
    border-radius: 3px;
    padding: 1rem 1.25rem;
    margin: 1.5rem 0;
  }
  & blockquote p {
    margin: 0;
  }

  /* Card */
  & .card {
    margin: 1.5rem 0;
    border-radius: 5px;
    border: 1px solid #eaeaea;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: box-shadow 0.2s ease;
  }
  & .card:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  }
  & .card > a {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: #666666;
    color: #666666;
    padding: 1.5rem;
    border: none;
    transition: color 0.2s ease;
  }
  & .card > a:hover {
    color: #111;
  }
  & .card > a > h4 {
    font-size: 1rem;
    font-weight: 600;
    color: #111;
    margin-top: 0;
    margin-bottom: 0.25rem;
  }
  & .card > a > small {
    font-size: 0.875rem;
    color: inherit;
  }

  /* Misc */
  & hr {
    border: 0;
    border-top: 1px solid #eaeaea;
    margin: 1.25rem 0;
  }
  & ul,
  & ol {
    padding-left: 1.5rem;
    margin: 1.25rem 0;
  }

  & li {
    font-size: 1rem;
  }
  & ul :global(li:before) {
    content: '-';
    color: #999999;
    position: absolute;
    margin-left: -1rem;
  }
  
  .video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 35px;
    height: 0;
    overflow: hidden;
  }

  .video-container iframe {
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
